'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import IonicappServices from '@/components/technologies/ionicapp-services';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Leverage The Power of Cross-Platform Mobile Apps Delivering Native Experience with Ionic App Development!"
                alt="hero image"
                title="hero image"
                width={582}
                height={550}
                path={'ionic-app-hero'}
                bgPath={'hero-bg-grunge'}
            >
                Ionic App <div>Development Company</div>
            </TechHeroApp>

            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Ionic App" />
            <ContetVideoSection title="Opting for Ionic Means UX Focused, Agile and Swift Mobile App – Guaranteed!">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        One of the major benefits of the Ionic framework is to develop once and deploy over multiple platforms.
                        This simply means that ionic based application leverage native experience over multiple operating systems.
                        Backed with Angular.js as a base, applications built using ionic is agile as well swift. Being free and
                        open-source, it allows access to codes of diverse mobile components.
                    </p>
                    <p className="fw-400 text-secondary fs-md">
                        It allows us to design and develop elegant and attractive UI’s with the help of Angular.js. Having access
                        to mobile SDK, plugin, Google APIs, Camera, themes UI library, applications built using Ionic leverages
                        native experience on all the platforms. It has the potential to leverage lightweight and progressive app
                        development that clicks the user’s mind immediately.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">So, what are you waiting for?</p>
                </>
            </ContetVideoSection>
            <IonicappServices title="Ionic App Development Services"></IonicappServices>
            <HireProcess
                bg="bg-ionicapp"
                pageTitle="Hire Custom Ionic App Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using Ionic."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For Ionic App Development?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best Ionic App Developers"
                desc="Select from different engagement models to hire Ionic App Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
